'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _ControlLabel = require('react-bootstrap/lib/ControlLabel');

var _ControlLabel2 = _interopRequireDefault(_ControlLabel);

var _Form = require('react-bootstrap/lib/Form');

var _Form2 = _interopRequireDefault(_Form);

var _FormControl = require('react-bootstrap/lib/FormControl');

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormGroup = require('react-bootstrap/lib/FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _canonical = require('../../utils/canonical');

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactIntl = require('react-intl');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPaginate = require('react-paginate');

var _reactPaginate2 = _interopRequireDefault(_reactPaginate);

var _PaginationWrapper = require('./PaginationWrapper.scss');

var _PaginationWrapper2 = _interopRequireDefault(_PaginationWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaginationWrapper = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(PaginationWrapper, _Component);

    function PaginationWrapper() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PaginationWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PaginationWrapper.__proto__ || (0, _getPrototypeOf2.default)(PaginationWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.mapAvailableViews = function (option, index) {
            return (0, _jsx3.default)('option', {
                value: option
            }, index, option === 'all' ? _this.context.intl.formatMessage({ id: option }) : option);
        }, _this.hrefBuilder = function (pathname, pageNumber) {
            var url = (0, _canonical.buildCanonicalUrlWithPageNum)(pathname, pageNumber);
            return pathname.includes('/c/') && pageNumber !== 1 ? url + '&parameters=' + encodeURIComponent((0, _stringify2.default)({ page: pageNumber })) : url;
        }, _this.handlePageChange = function (event) {
            return _this.props.onPageChange(event.selected);
        }, _this.handlePageSizeChange = function (event) {
            return _this.props.onPageSizeChange(event.target.value);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(PaginationWrapper, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['availableViews', 'filteredItemCount', 'page', 'pageSize', 'paginatorContainerOverrideClass', 'paginatorOverrideClass', 'paginatorViewCountOverrideClass', 'pathname', 'totalItemsCount']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                availableViews = _props.availableViews,
                baseUrl = _props.baseUrl,
                canonicalURL = _props.canonicalURL,
                onSubmit = _props.onSubmit,
                page = _props.page,
                pageSize = _props.pageSize,
                paginatorOverrideClass = _props.paginatorOverrideClass,
                paginatorContainerOverrideClass = _props.paginatorContainerOverrideClass,
                paginatorViewCountOverrideClass = _props.paginatorViewCountOverrideClass,
                pathname = _props.pathname,
                totalItemsCount = _props.totalItemsCount;
            var filteredItemCount = this.props.filteredItemCount;


            if (typeof filteredItemCount === 'undefined' || global.__SERVER__) {
                filteredItemCount = totalItemsCount;
            }

            var itemsToDisplay = isNaN(pageSize) ? totalItemsCount : pageSize;
            var numPages = Math.ceil(filteredItemCount / itemsToDisplay);
            var nextButtonClassName = numPages === page ? _PaginationWrapper2.default.grayed : '';
            var prevButtonClassName = page === 1 ? _PaginationWrapper2.default.grayed : '';
            var canonical = canonicalURL ? '' + baseUrl + canonicalURL : '' + baseUrl + pathname;

            var nextLink = '';
            var nextUrl = this.hrefBuilder(canonical, page + 1);
            if (numPages !== page) {
                nextLink = (0, _jsx3.default)('link', {
                    rel: 'next',
                    href: nextUrl
                });
            }
            var currentLink = (0, _jsx3.default)('link', {
                rel: 'canonical',
                href: this.hrefBuilder(canonical, page)
            });
            var prevLink = '';
            var prevUrl = this.hrefBuilder(canonical, page - 1);
            if (page > 1) {
                prevLink = (0, _jsx3.default)('link', {
                    rel: 'prev',
                    href: prevUrl
                });
            }

            return (0, _jsx3.default)('div', {
                className: _PaginationWrapper2.default['pagination-container'] + ' ' + paginatorContainerOverrideClass
            }, void 0, (0, _jsx3.default)(_reactHelmet2.default, {}, void 0, nextLink, currentLink, prevLink), (0, _jsx3.default)('div', {}), (0, _jsx3.default)(_reactPaginate2.default, {
                activeClassName: 'active',
                breakLabel: (0, _jsx3.default)('span', {
                    className: _PaginationWrapper2.default.break + ' ' + _PaginationWrapper2.default.disabled
                }, void 0, '\u2026'),
                containerClassName: _PaginationWrapper2.default.paginator + ' paginator' + this.guid + ' ' + paginatorOverrideClass,
                hrefBuilder: function hrefBuilder(num) {
                    return _this2.hrefBuilder(_this2.props.pathname, num);
                },
                forcePage: page - 1,
                marginPagesDisplayed: 1,
                nextLabel: (0, _jsx3.default)('span', {
                    className: nextButtonClassName
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'next'
                }), ' ', (0, _jsx3.default)(_reactFontawesome2.default, {
                    className: _PaginationWrapper2.default.chevron,
                    icon: ['fas', 'chevron-right']
                })),
                onPageChange: this.handlePageChange,
                pageCount: numPages,
                pageRangeDisplayed: 2,
                previousLabel: (0, _jsx3.default)('span', {
                    className: prevButtonClassName
                }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                    className: _PaginationWrapper2.default.chevron,
                    icon: ['fas', 'chevron-left']
                }), ' ', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'previous'
                })),
                subContainerClassName: 'pages pagination'
            }), (0, _jsx3.default)(_Form2.default, {
                className: _PaginationWrapper2.default['pagination-view-count'] + ' ' + paginatorViewCountOverrideClass,
                inline: true,
                onSubmit: onSubmit
            }, void 0, (0, _jsx3.default)(_FormGroup2.default, {
                className: _PaginationWrapper2.default['page-size'],
                controlId: 'view'
            }, void 0, (0, _jsx3.default)(_ControlLabel2.default, {}, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'view'
            }), ':\xA0'), (0, _jsx3.default)(_FormControl2.default, {
                value: pageSize,
                componentClass: 'select',
                placeholder: 'select',
                onChange: this.handlePageSizeChange
            }, void 0, availableViews.map(this.mapAvailableViews)))));
        }
    }]);
    return PaginationWrapper;
}(_react.Component), _class.contextTypes = {
    intl: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
    baseUrl: '',
    filteredItemCount: 0,
    page: 0,
    paginatorContainerOverrideClass: '',
    paginatorOverrideClass: '',
    paginatorViewCountOverrideClass: '',
    totalItemsCount: 0
}, _temp2);
exports.default = PaginationWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/PaginationWrapper.js
// module id = +Feu
// module chunks = 57